import stepEngineReducer from 'app/modules/step-engine/service/store/step-engine-reducer';
import { Step } from 'app/modules/step-engine/utils/step-engine-constants';

/* eslint-disable complexity */
export const gtmStepsMapper = (dataKey, globalData) => {
  let gtmAnswer;
  const dataKeyCamelCase = Step[dataKey]
  switch (dataKeyCamelCase) {
    case Step.DAMAGED_GOOD_DATE:
    case Step.COVER_SELECTION:
    case Step.CLAIM_LOCATION:
    case Step.UPLOAD_DECLARATION:  
    case Step.BENEFIT_TYPE_SELECTION:
    case Step.BENEFIT_DEPOSIT_METHOD:
    case Step.STOLEN_TYPE_SELECTION:
    case Step.BURGLARY_DEVICE_SELECTION:
      gtmAnswer = globalData[dataKeyCamelCase]?.label;
      break;
    case Step.CHOOSE_DAMAGED_GOODS:
    case Step.DAMAGED_GOOD_SELECTION:
      // On trie par marque ou par label afin que l'ordre de séléction ne change pas le libellé concaténé envoyé à GTM
      gtmAnswer = globalData[dataKeyCamelCase]?.sort((a, b) =>
        a.brand ? a.brand.localeCompare(b.brand) : a.code - b.code).map(e =>
          e.brand ? e.brand + "_" + (e.modal ?? e.model) : e.label).join(" & ");
      break;
    case Step.CLAIM_TRIGGER_NATURE:
    case Step.CLAIM_RESULT_SELECTION:
    case Step.DAMAGED_GOOD_DYSFUNCTION_SELECTION:
    case Step.THEFT_PLACE_SELECTION:
      // On trie pour que l'ordre de séléction par l'utilisateur ne change pas le libellé concaténé envoyé à GTM
      gtmAnswer = globalData[dataKeyCamelCase].sort((a, b) => a.code - b.code).map(e => e.label).join(" & ");
      break;
    case Step.BENEFIT_POINT_SELECTION:
      gtmAnswer = globalData[dataKeyCamelCase].code;
      break;
    case Step.UPDATE_BENEFIT_ADDRESS_DETAILS:
      gtmAnswer = `${globalData[dataKeyCamelCase].streetNumber}_${globalData[dataKeyCamelCase].zipCode}_${globalData[dataKeyCamelCase].city}`;
      break;
    default:
      gtmAnswer = undefined
      break;
  }
  return gtmAnswer;
};